var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 54,
    viewBox: "0 0 41 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6013_7555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.48485 27.4231C4.48485 25.533 5.99148 23.9994 7.84848 23.9994C9.70549 23.9994 11.2121 25.533 11.2121 27.4231V35.4118H4.48485V27.4231ZM0 27.4231V43.4004C0 47.8156 3.5108 51.3891 7.84848 51.3891C12.1862 51.3891 15.697 47.8156 15.697 43.4004V30.6757C15.8231 32.038 16.2716 33.3861 17.0845 34.5844L26.0892 47.944C28.5769 51.6316 33.4682 52.5303 37.021 49.9482C40.5739 47.3662 41.4358 42.2806 38.9481 38.593L29.9434 25.2334C27.4557 21.5387 22.5574 20.6471 19.0116 23.2291C17.0494 24.6557 15.9072 26.8525 15.697 29.1493V27.4231C15.697 23.008 12.1862 19.4345 7.84848 19.4345C3.5108 19.4345 0 23.008 0 27.4231ZM20.7845 32.0023C19.6633 30.3404 20.0837 28.058 21.6184 26.9381C23.104 25.8611 25.1572 26.2035 26.2434 27.8083L30.9384 34.7698L25.3394 38.7642L20.7845 32.0023ZM34.4072 46.2321C34.3511 46.2749 34.2951 46.3106 34.239 46.3462L34.5193 46.1465C34.4843 46.175 34.4492 46.2036 34.4072 46.2321Z",
    fill: "#005A9E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2978 15.9508C18.1497 15.9508 18.9932 15.783 19.7803 15.457C20.5673 15.131 21.2824 14.6532 21.8848 14.0508C22.4872 13.4484 22.965 12.7333 23.291 11.9463C23.617 11.1592 23.7848 10.3157 23.7848 9.46379C23.7848 8.6119 23.617 7.76836 23.291 6.98132C22.965 6.19428 22.4872 5.47915 21.8848 4.87678C21.2824 4.2744 20.5673 3.79657 19.7803 3.47057C18.9932 3.14457 18.1497 2.97678 17.2978 2.97678C15.5773 2.97678 13.9273 3.66023 12.7108 4.87678C11.4942 6.09333 10.8108 7.74333 10.8108 9.46379C10.8108 11.1843 11.4942 12.8342 12.7108 14.0508C13.9273 15.2673 15.5773 15.9508 17.2978 15.9508ZM17.1306 12.0874L20.7345 7.76275L19.6274 6.84015L16.528 10.5587L14.9243 8.9542L13.9051 9.97338L16.0674 12.1357L16.6253 12.6936L17.1306 12.0874Z",
    fill: "#005A9E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6013_7555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.3636,
    height: 36.5195,
    fill: "white",
    transform: "translate(0 17.152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablets);
export default __webpack_public_path__ + "static/media/tablets.d31e33a61880e86cb34618461dd96dd0.svg";
export { ForwardRef as ReactComponent };